import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b0e7025c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "info-box",
  id: "InfoBox"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "title"
}, "短信模板信息", -1));
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import { getSmsTemplateById } from '@/api/sms';
import { TEMPLATE_STATUS_TYPE } from '../config';
import { PLATFORM_TYPE, TEMPLATE_TYPE } from '../sms-module/config';
export default {
  __name: 'index',
  setup(__props) {
    const route = useRoute();
    const {
      id
    } = route.params;
    console.log(id);
    const smsTemplate = ref({});
    const loading = ref(false);
    const getSmsTemplate = async () => {
      loading.value = true;
      const res = await getSmsTemplateById(id);
      smsTemplate.value = res;
      loading.value = false;
    };
    getSmsTemplate();
    return (_ctx, _cache) => {
      const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");
      const _component_el_descriptions = _resolveComponent("el-descriptions");
      const _component_el_card = _resolveComponent("el-card");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_el_card, {
        shadow: "never"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_hoisted_2, _withDirectives((_openBlock(), _createBlock(_component_el_descriptions, {
          column: 2,
          border: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
            label: "短信接入方唯一标识"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(smsTemplate.value.appId), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "短信接入方名称"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(smsTemplate.value.appName), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "接入的短信平台"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(PLATFORM_TYPE)[smsTemplate.value.platform]), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "模板中参数个数(占位符个数)"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(smsTemplate.value.paramsCount), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "短信模板占位符变量名称, 多个变量名称以','隔开",
            span: 2
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(smsTemplate.value.paramsName), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "短信签名名称"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(smsTemplate.value.signName), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "第三方平台模板编号"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(smsTemplate.value.templateCode), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "审核通过的模板内容格式"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(smsTemplate.value.templateContent), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "第三方平台模板名称"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(smsTemplate.value.templateName), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "模板审核状态"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(TEMPLATE_STATUS_TYPE)[smsTemplate.value.templateStatus]), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "模板类型",
            span: 2
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(TEMPLATE_TYPE)[smsTemplate.value.templateType]), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "模板审核备注，申请模板审核未通过会显示具体原因",
            span: 2
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(smsTemplate.value.reason), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            span: 2,
            label: "备注",
            direction: "vertical"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(smsTemplate.value.remark), 1)]),
            _: 1
          })]),
          _: 1
        })), [[_directive_loading, loading.value]])])]),
        _: 1
      });
    };
  }
};